import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"

export const Gradient = styled.div`
  ${({theme}) => css`
    border-radius: ${theme.border.radius.large} ${theme.border.radius.large} 0 0;
    background-image: linear-gradient(to left, ${theme.colors.primary1}, ${theme.colors.primary2});
    padding: ${theme.spacing.oneAndHalf};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.three} ${theme.spacing.five};
    `}
  `}
`

export const BannerImage = styled.img`
  max-width: 100%;
  height: auto;
`

export const ResponsiveMargin = styled.div`
  ${({theme}) => css`
    margin: ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: ${theme.spacing.eight};
    `}
  `}
`

export const BannerLayout = styled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
    
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.desktop`
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
    `}
  `}
`

export const ResponsiveCard = styled(Card)`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.grey03};
    box-shadow: ${theme.shadows.low};
    background-color: ${theme.colors.utility.white};
  `}
`

export const MobileCta = styled(Button)`
  ${({theme}) => css`
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 10px;
    ${theme.mediaQueries.minWidthMedia.tablet`
      display: none;
    `}
  `}
`
